'use client'

import type { FC } from 'react'
import type { VideoSlide } from './VideoRows'
import { VideoRows } from './VideoRows'
import { motion } from 'motion/react'
import { useTranslator } from '@/hooks'
import styled from 'styled-components'
import { designGrid, mq, presets } from '@/styles'

type Props = {
  data: {
    firstSliderVideos: VideoSlide[]
    secondSliderVideos: VideoSlide[]
    thirdSliderVideos: VideoSlide[]
    title?: string
  }
}

export const HeaderVideoRows: FC<Props> = ({ data }) => {
  const { t } = useTranslator()

  return (
    <HeaderStyled>
      <VideoRows
        className='rows-wrapper'
        firstRowVideos={data.firstSliderVideos}
        secondRowVideos={data.secondSliderVideos}
        thirdRowVideos={data.thirdSliderVideos}
      />

      <hgroup>
        <motion.h1
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: .3, delay: .3, ease: 'easeInOut' }}
        >
          {data.title ?? t('project.header_title')}
        </motion.h1>
      </hgroup>
    </HeaderStyled>
  )
}

const HeaderStyled = styled.header`
  display: grid;
  align-items: center;
  height: 100dvh;
  height: 100vh;
  justify-content: center;
  margin-bottom: 105px;
  margin-top: 75px;
  overflow: hidden;
  position: relative;
  width: 100dvw;
  width: 100vw;
  z-index: 9;

  hgroup,
  .rows-wrapper {
    grid-column: 1 / span 1;
    grid-row: 1 / span 1;
  }

  hgroup {
    ${designGrid({})}
    position: relative;
    z-index: 2;
  }

  ${mq.greaterThan('tablet')} {
    margin-bottom: 190px;
    margin-top: 0;
  }

  h1 {
    ${presets.font60_110()}
    grid-column: 1 / span 6;
    position: relative;
    text-align: center;
    z-index: 2;

    ${mq.greaterThan('tablet')} {
      grid-column: 3 / span 8;
    }
  }
`
